<template>
  <div class="position-relative">
    <custom-callout
      class="mt-4"
      :class="canSeeAlert(item.statusQueue) && !isCurrent && 'mb-5rem'"
      :border-color="'secondary-5'"
      :status-color="'blue'"
      :has-toggle="false"
      ref="callout"
    >
      <div class="row px-lg- py-md-3 ml-n4 mr-1">
        <div
          class="col-12 d-flex"
          :class="isShared || isInactive ? 'col-lg-3' : 'col-lg-4'"
        >
          <i
            class="text-orange mr-4 font-24 icon-topic"
            :class="[item.topic.icon, isMobile && 'font-30 ml-2']"
          ></i>
          <div class="w-80">
            <label for="" class="text-muted font-weight-normal font-14">
              Nombre del informe:
            </label>
            <p class="font-weight-normal font-16 text-wrap">{{ item.name }}</p>
          </div>
        </div>
        <hr v-if="isShared || isInactive" class="d-block d-md-none divider" />
        <div v-if="isShared || isInactive" class="col-12 col-lg-2 ml-2 ml-md-0">
          <label for="" class="text-muted font-weight-normal font-14">
            {{
              isShared
                ? 'Fecha de compartido:'
                : isInactive
                ? 'Fecha de inactivación:'
                : ''
            }}
          </label>
          <p class="font-weight-normal font-16">
            <span v-if="isShared">
              {{ item.shareData.sharedDate | datetime }}
            </span>
            <span v-if="isInactive">{{ item.updatedDate | datetime }}</span>
          </p>
        </div>
        <hr class="d-block d-md-none divider" />
        <div
          class="col-12 ml-2 ml-md-0"
          :class="isShared || isInactive ? 'col-lg-2' : 'col-lg-3'"
        >
          <label for="" class="text-muted font-weight-normal font-14">
            Fecha de última generación:
          </label>
          <p class="font-weight-normal font-16">
            {{ item.lastBuild | datetime }}
          </p>
        </div>
        <div
          class="col-12 ml-2 ml-md-0"
          :class="isShared || isInactive ? 'col-lg-3' : 'col-lg-2'"
        >
          <label for="" class="text-muted font-weight-normal font-14">
            Creado por:
          </label>
          <p class="font-weight-normal font-16">{{ item.createdBy }}</p>
        </div>
        <hr class="d-block d-md-none divider" />
        <div
          class="col-12 d-flex justify-content-lg-end align-items-center mt-2 mt-md-0 flex-wrap flex-md-nowrap pr-0 pr-lg-2"
          :class="isShared || isInactive ? 'col-lg-2' : 'col-lg-3'"
        >
          <i
            v-if="shared"
            class="fas fa-link font-weight-normal unfill mr-2 m-right"
          ></i>
          <div v-if="!isInactive && !canSeeOptions(item.statusQueue)">
            <div
              v-if="!item.isFavorite"
              class="btn-star d-flex justify-content-center align-items-center text-warning cursor-pointer mr-4"
            >
              <i
                class="fa-solid fa-star fill cursor-pointer"
                @click="addToFavorite"
              ></i>
              <i class="fa-regular fa-star unfill cursor-pointer"></i>
            </div>
            <div
              v-else
              class="btn-star btn-star-fill d-flex justify-content-center align-items-center text-warning cursor-pointer mr-3"
            >
              <i
                class="fa-solid fa-star cursor-pointer"
                @click="removeToFavorite"
              ></i>
            </div>
          </div>

          <div v-if="isMobile" class="row ml-2 mt-2">
            <div
              v-for="tag in item.tags"
              :key="tag.id"
              class="tag px-3 mr-2 d-flex"
            >
              <p class="font-16 font-weight-normal mt-1">
                {{ tag.name }}
              </p>
            </div>
          </div>

          <div
            class="row mt-3 ml-1 ml-lg-0 mt-lg-0 flex-grow-1 flex-lg-grow-0 mb-n2 mb-lg-0"
            :class="isMobile && 'w-100'"
          >
            <div class="col-12 pr-0 pr-lg-0">
              <dropdown
                v-if="!isInactive && !canSeeOptions(item.statusQueue)"
                :items="action"
                title="Acciones"
                id="btn-actions"
              />
            </div>
          </div>
          <div
            class="row mt-3 ml-2 ml-lg-0 mt-lg-0 flex-grow-1 flex-lg-grow-0"
            :class="isMobile && 'w-100'"
          >
            <div class="col-12">
              <div
                class="d-flex justify-content-lg-end justify-content-start"
                :class="isMobile && 'w-100 ml-2'"
              >
                <action-button
                  v-if="isInactive && canActivate"
                  class="button-size"
                  :class="isMobile && 'w-100'"
                  id="modal-btn-cancelar"
                  variant="outline-success btn-green"
                  type="button"
                  i="fas fa-caret-circle-right"
                  @click="handleActivate"
                >
                  Activar
                </action-button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isMobile" class="col-12 d-flex">
          <div
            v-for="tag in listOfTags"
            :key="tag.id"
            class="px-3 mr-2 d-flex"
            :class="tag.hasOwnProperty('ticketId') ? 'ticket' : 'tag'"
          >
            <div
              class="d-flex justify-content-center align-items-baseline mt-1"
            >
              <i
                v-if="tag.hasOwnProperty('ticketId')"
                class="fad fa-headset font-16 text-orange mr-2"
              />
              <p class="font-16 font-weight-normal">
                {{ tag.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </custom-callout>
    <div
      v-if="canSeeAlert(item.statusQueue) && !isCurrent"
      :class="alertClass(item.statusQueue)"
      class="rb-alert rounded-bottom pr-2 px-md-3 d-flex align-items-center position-absolute"
    >
      <i
        v-if="isPending"
        class="fas fa-hourglass-half fa-flip font-24 icon-sand-animate mx-3 ml-lg-2"
      ></i>
      <i
        v-if="isCompleted"
        class="fas fa-check-circle font-24 icon-complete mx-3 ml-lg-2"
      ></i>
      <img
        v-if="isRunning"
        class="rb-loading"
        src="@/assets/img/loading.svg"
        alt=""
        srcset=""
      />
      <i
        v-if="isFailed || isFailedTimeout"
        class="fas fa-hourglass-half font-24 mx-3 ml-lg-2"
        style="margin-left: 1rem"
      />
      <p
        v-if="isPending"
        class="font-weight-normal my-auto"
        :class="isMobile ? 'font-12' : 'font-14'"
      >
        Su informe está pendiente de generación. Oprima
        <a
          class="text-dark-yellow text-undeline font-weight-bold cursor-pointer"
          @click="handleCancel"
        >
          <strong>aquí</strong>
        </a>
        para cancelar esta acción.
      </p>

      <p
        v-if="isRunning"
        class="font-weight-normal my-auto"
        :class="isMobile ? 'font-12' : 'font-14'"
      >
        Su informe está siendo generado. Una vez finalizado, aparecerá un enlace
        para descargarlo.
      </p>

      <p
        v-if="isFailedTimeout"
        class="font-weight-normal my-auto"
        :class="isMobile ? 'font-12' : 'font-14'"
      >
        El reporte sobrepasó el tiempo máximo de ejecución, por lo cual no pudo
        ser generado, favor intentar nuevamente. Si la situación persiste favor
        contactar Asistencia MIPE.
      </p>

      <p
        v-if="isFailed"
        class="font-weight-normal my-auto"
        :class="isMobile ? 'font-12' : 'font-14'"
      >
        Durante el proceso de ejecución del reporte, se encontró una situación
        de configuración que está impidiendo generar el reporte, favor de
        comunicarse con Asistencia MIPE.
      </p>

      <p
        v-if="isCompleted"
        class="font-weight-normal my-auto"
        :class="isMobile ? 'font-12' : 'font-14'"
      >
        Su informe ha sido generado. Este archivo expirará en
        <strong>24</strong>
        horas. Oprima
        <a
          class="text-undeline font-weight-bold cursor-pointer"
          @click="handleDownload"
        >
          <strong>aquí</strong>
        </a>
        para descargar el informe.
      </p>
    </div>
    <div>
      <generate-inform
        v-if="isCurrent && viewToDisplay === rbViewDisplayEnum.GENERATE_INFORM"
        v-model="item"
        :filters="item.selectedFilters"
        @close="closeGenerateInform"
        @saved="handleGenerate"
      />
      <more-information
        v-if="isCurrent && viewToDisplay === rbViewDisplayEnum.MORE_INFORMATION"
        v-model="item"
        @close="closeGenerateInform"
      />
      <share-inform
        v-if="isCurrent && viewToDisplay === rbViewDisplayEnum.SHARE"
        :inform-id="item.id"
        v-model="item"
        @close="closeGenerateInform"
        @load="refreshResults"
        @updateShareData="updateShareData"
      />
      <tags
        v-if="isCurrent && viewToDisplay === rbViewDisplayEnum.TAG"
        v-model="item"
        @close="closeGenerateInform"
        @load-tags="loadTags"
      />
      <related
        v-if="isCurrent && viewToDisplay === rbViewDisplayEnum.RELATED"
        v-model="item"
        @close="closeGenerateInform"
        @load-tickets="loadTickets"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { name as specialReportModuleName } from '@/modules/special-report/store'
import { name as userModuleName } from '@/modules/user/store/'
import CustomCallout from 'custom-callout'
import Dropdown from 'dropdown'
import ActionButton from 'ActionButton'
import rbStatus from '@/utils/constants/rbStatus.js'
import GenerateInform from './GenerateInform.vue'
import MoreInformation from './MoreInformation.vue'
import ShareInform from './ShareInform.vue'
import Tags from './Tags.vue'
import Related from './Related.vue'
import SpecialService from '@/services/api/special.api'
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'
import utils from '@/utils/utilities'
import { date } from '@/utils/filters'
import rbViewDisplay from '@/utils/constants/rbViewDisplay.js'

export default {
  name: 'ReportRow',
  components: {
    CustomCallout,
    Dropdown,
    ActionButton,
    GenerateInform,
    MoreInformation,
    ShareInform,
    Tags,
    Related,
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isShared: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showGenerateInform: false,
    current: false,
    viewToDisplay: rbViewDisplay.UNSET,
  }),
  computed: {
    ...mapState(specialReportModuleName, ['currentRow']),
    ...mapState(userModuleName, ['user']),
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    rbViewDisplayEnum() {
      return rbViewDisplay
    },
    action() {
      return [
        {
          label: 'Ver',
          icon: 'fas fa-eye text-green',
          class: 'pr-1 mr-2',
          visible: !this.isInactive,
          click: () => {
            this.$router.push({
              name: 'SpecialReportManager',
              params: { id: this.item.id },
            })
          },
        },
        {
          label: 'Información adicional',
          icon: 'fas fa-info-circle text-green',
          class: 'pr-1 mr-2',
          visible: !this.isInactive,
          click: () => {
            this.setCurrentRow(this.item.id)
            this.viewToDisplay = rbViewDisplay.MORE_INFORMATION
          },
        },
        {
          label: 'Generar informe',
          icon: 'fas fa-file-export text-green',
          class: 'pr-1 mr-2 border-top',
          visible: !this.isInactive,
          click: () => {
            this.setCurrentRow(this.item.id)
            this.viewToDisplay = rbViewDisplay.GENERATE_INFORM
          },
        },
        {
          label: 'Copiar informe',
          icon: 'fas fa-copy text-green',
          class: 'pr-1 mr-2',
          visible: this.canCopyInform,
          click: () => {
            this.$router.push({
              name: 'SpecialReportManager',
              params: { id: this.item.id },
              query: { copy: true },
            })
          },
        },
        {
          label: 'Compartir',
          icon: 'fas fa-link text-green',
          class: 'pr-1 mr-2',
          visible: !this.sharedWithMe,
          click: () => {
            this.setCurrentRow(this.item.id)
            this.viewToDisplay = rbViewDisplay.SHARE
          },
        },
        {
          label: 'Etiquetar informe',
          icon: 'fas fa-tag text-green',
          class: 'pr-1 mr-2',
          visible: !this.isInactive,
          click: () => {
            this.setCurrentRow(this.item.id)
            this.viewToDisplay = rbViewDisplay.TAG
          },
        },
        {
          label: 'Inactivar',
          icon: 'fas fa-ban text-red',
          class: 'pr-1 mr-2',
          visible: !this.sharedWithMe,
          click: () => {
            this.handleInactivate(this.item.id)
          },
        },
        {
          label: 'Relacionar con DE Ticket',
          icon: 'fas fa-headset text-green',
          class: 'pr-1 mr-2 border-top',
          visible: this.canRelateTicket,
          click: () => {
            this.setCurrentRow(this.item.id)
            this.viewToDisplay = rbViewDisplay.RELATED
          },
        },
      ]
    },
    formatDate() {
      return (d) => date(d)
    },
    canSeeAlert() {
      const list = [
        rbStatus.Pending,
        rbStatus.Running,
        rbStatus.Completed,
        rbStatus.Failed,
        rbStatus.Canceled,
      ]
      return (status) => list.includes(status) && !this.item.isExpired
    },
    canSeeOptions() {
      const list = [rbStatus.Pending, rbStatus.Running]
      return (status) => list.includes(status)
    },
    isCurrent() {
      return this.currentRow === this.item.id
    },
    iconCustomClass() {
      return (icon) => `${icon} icon-topic`
    },
    alertClass() {
      return (state) => {
        const keyIndex = Object.values(rbStatus).indexOf(state)

        return `alert-${Object.keys(rbStatus)[keyIndex].toLowerCase()}`
      }
    },
    isPending() {
      return this.item.statusQueue === rbStatus.Pending
    },
    isRunning() {
      return this.item.statusQueue === rbStatus.Running
    },
    isCompleted() {
      return this.item.statusQueue === rbStatus.Completed
    },
    isFailedTimeout() {
      return (
        this.item.statusQueue === rbStatus.Failed &&
        this.item.messageQueue == 'Timeout'
      )
    },
    isFailed() {
      return (
        this.item.statusQueue === rbStatus.Failed &&
        this.item.messageQueue != 'Timeout'
      )
    },
    isInactive() {
      return this.item.status === rbStatus.Inactive
    },
    showDropdown() {
      return this.action.some((e) => e.visible)
    },
    canActivate() {
      return !this.sharedWithMe
    },
    sharedWithMe() {
      return this.item?.shareData?.sharedWithMe
    },
    shared() {
      return this.item?.shareData?.shared
    },
    listOfTags() {
      const tags = this.item?.tags
      const tickets = this.item?.tickets

      return [...tickets, ...tags]
    },
    canRelateTicket() {
      return this.userHasPermissions(
        'menu.report.specialInform.relatetodeticket'
      )
    },
    canCopyInform() {
      return (
        this.userHasPermissions('menu.report.specialInform.copy') &&
        this.item.createdById === this.user.profile.sub
      )
    },
  },
  methods: {
    ...mapActions(specialReportModuleName, [
      'setCurrentRow',
      'setTagsCounter',
      'setHasTickets',
    ]),
    handleGenerate() {
      this.$emit('load')
      this.closeGenerateInform()
    },
    async handleCancel() {
      const result = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea cancelar la ejecución del reporte?`,
        'Sí',
        'No'
      )

      if (result) {
        const { data } = await SpecialService.cancel(this.item.id).catch(
          (err) => {
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error'
            )
          }
        )

        if (data) {
          this.ShowToast(
            'Proceso Exitoso',
            'La ejecución del reporte ha sido cancelada exitosamente.',
            'success'
          )
          this.$emit('load')
        }
      }
    },
    async handleDownload() {
      await SpecialService.download(this.item.id)
        .then((res) => utils.convertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error')
        })
    },
    closeGenerateInform() {
      this.setCurrentRow(null)
      this.viewToDisplay = rbViewDisplay.UNSET
    },
    closeShareInform() {
      this.setCurrentRow(null)
      this.viewToDisplay = rbViewDisplay.UNSET
      this.$emit('load')
    },
    async handleInactivate() {
      const result = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea inactivar el reporte?`,
        'Sí',
        'No'
      )

      if (result) {
        const { data } = await SpecialService.inactivate(this.item.id)
        if (data) {
          this.ShowToast(
            'Proceso Exitoso',
            'La inactivación del reporte ha sido realizada exitosamente.',
            'success'
          )
          this.$emit('load')
        }
      }
    },
    async handleActivate() {
      const result = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea activar el reporte?`,
        'Sí',
        'No'
      )

      if (result) {
        const { data } = await SpecialService.activate(this.item.id)
        if (data) {
          this.ShowToast(
            'Proceso Exitoso',
            'La activación del reporte ha sido realizada exitosamente.',
            'success'
          )
          this.$emit('load')
        }
      }
    },
    async addToFavorite() {
      const { data } = await SpecialService.addToFavorites(this.item.id)
      if (data) {
        this.$emit('load')
      }
    },
    async removeToFavorite() {
      const { data } = await SpecialService.removeToFavorites(this.item.id)
      if (data) {
        this.$emit('load')
      }
    },
    async loadTags() {
      const { data } = await SpecialService.getTagByQueryBuilderId(this.item.id)
      if (data) {
        this.setTagsCounter(data.length)
        this.item.tags = data
      }
    },
    async loadTickets() {
      const { data } = await SpecialService.getTicketsByQueryBuilderId(
        this.item.id
      )
      if (data) {
        this.item.tickets = data
        this.setHasTickets(Math.random())
      }
    },
    refreshResults() {
      this.$emit('load')
    },
    updateShareData(value) {
      if (this.item.shareData) this.item.shareData.shared = value
      else {
        this.item.shareData = {
          shared: value,
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
hr.divider {
  border: 1px solid #727272;
  opacity: 0.22;
  width: 100%;
  margin-left: 1rem !important;
}

.tag {
  width: fit-content;
  height: 35px;
  border-radius: 18px;
  border: 1px solid #b5c3bc;
  opacity: 1;
}
.ticket {
  width: fit-content;
  height: 35px;
  border-radius: 18px;
  border: 1px solid #f57e4a;
  opacity: 1;
}

.unfill {
  color: #b5c3bc;
}

.fill {
  color: #f8b539;
}

.btn-star:hover {
  border: 1px solid #feefb4;
  background-color: #fff5e8;
}

.btn-star-fill {
  border: 1px solid #feefb4;
  background-color: #fff5e8 !important;
}

.btn-star:hover .unfill,
.btn-star .fill {
  display: none;
}

.btn-star:hover .fill {
  display: inline;
}

.row-container {
  z-index: 2;
  position: static;
}

.icon-topic {
  margin-top: 6px;
}

.icon-complete {
  margin-left: 1.139rem;
}

.icon-sand-animate {
  --fa-flip-x: 1;
  --fa-flip-y: 0;
  --fa-animation-duration: 2s;
}

p {
  overflow-wrap: break-word;
}

.rb-alert {
  top: 97%;
  left: 0;
  width: 100%;
  padding: 10px 0;
}

.alert-pending {
  background-color: #feeeb7;

  & p,
  i {
    color: #af6717;
  }
}

.alert-running,
.alert-failed,
.alert-canceled {
  background-color: #fdeee8;

  & p,
  i {
    color: #af4208;
  }
}

.alert-completed {
  background-color: #d0f0e0;

  & a {
    color: #0d764d;
  }

  & p,
  i {
    color: #0d764d;
  }
}

.mb-5rem {
  margin-bottom: 5rem !important;
}

.text-dark-yellow {
  color: #af6717;
}

::v-deep
  div.bg-secondary-3.border-radius--light.border--top.border-left--color-secondary-5 {
  border-left-width: 4px;
}

@media only screen and (max-width: 600px) {
  ::v-deep div.dropdown-menu {
    width: 320px !important;
  }
}
::v-deep .bg-secondary-3 {
  background-color: #fafafa;
}

.btn-star {
  width: 42px;
  height: 38px;
  border-radius: 4px;
  background: #f2f2f2;
}

.w-80 {
  width: 80% !important;
}

.rb-loading {
  -webkit-animation: spin 4s linear infinite;
  -moz-animation: spin 4s linear infinite;
  animation: spin 4s linear infinite;
  margin-left: 1.139rem;
  margin-right: 1.3rem;
}

@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@media (min-width: 1400px) {
  .m-right {
    margin-right: 5rem !important;
  }
}
</style>
